import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import '@fortawesome/fontawesome-free/css/all.css' //Font Awesome Icons
import 'vuesax/dist/vuesax.css' // Vuesax

Vue.use(Vuesax)

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css';

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// Service worker
// import './registerServiceWorker'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// NProgress SCSS
import './assets/scss/nprogress.scss'

// AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.withCredentials = true;

Vue.use(VueAxios, axios)

// Vuesax admin Filters
import './filters/filters'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// Import global Mixin\s
import './mixin'

Vue.config.productionTip = false

// Pusher for live-data
import Echo from "laravel-echo"
import 'pusher-js'
// import './registerServiceWorker'

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '8853d0030db0f02dfe37',
    cluster: 'eu',
    forceTLS: true,
    disableStats: true,
    encrypted: true
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
